"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURL = getURL;
exports.flattenConfig = flattenConfig;

var _log = require("./log.utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getURL(url, doneFunction, element) {
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    try {
      if (xhr.readyState === 4) {
        doneFunction(JSON.parse(xhr.responseText));
      }
    } catch (e) {
      (0, _log.log)("[ERROR] MTN ".concat(element, " - Error on fetching configuration."));
      (0, _log.log)(e);
      (0, _log.log)(xhr.responseText);
      doneFunction({});
    }
  };

  xhr.open('GET', url);
  xhr.send();
}

function _isObject(value) {
  return value && _typeof(value) === 'object' && value.constructor === Object;
}

function flattenConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var flattenedConfig = {};
  var keys = Object.keys(config);
  keys.forEach(function (k) {
    var subConfig = config[k];

    if (_isObject(subConfig)) {
      var subKeys = Object.keys(subConfig);
      subKeys.forEach(function (sk) {
        flattenedConfig["".concat(k).concat(sk.charAt(0).toUpperCase()).concat(sk.slice(1))] = subConfig[sk];
      });
    } else {
      flattenedConfig[k] = subConfig;
    }
  });
  return flattenedConfig;
}